<ion-button
  (click)="showRequestPromotionalCreditsModal()"
  fill="outline"
  size="default"
>
  <ion-icon
    slot="start"
    aria-hidden="true"
    src="../assets/material-symbols/payments_24dp.svg"
  ></ion-icon>
  Solicita créditos promocionales
</ion-button>
